import { render } from "./categorias-musicales.vue?vue&type=template&id=3603e88e&scoped=true"
import script from "./categorias-musicales.vue?vue&type=script&lang=js"
export * from "./categorias-musicales.vue?vue&type=script&lang=js"

import "./categorias-musicales.vue?vue&type=style&index=0&id=3603e88e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3603e88e"]])

export default __exports__